import { DateTime } from "luxon";
import React from "react";
import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import { ReactComponent as Euro } from "../../assets/new-icons/euroIcon.svg";

import DownloadIcon from "@mui/icons-material/Download";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

function Item(props) {
  const navigate = useNavigate();
  const { data_emissione, tag, numero_fattura, pagato, url, importo, } = props.data;
  const setOverlay = props.setOverlay;
  const setInvoice = props.setInvoice;
  const method = useSelector((user) => user.user.datiPagamento.method_name);
  const getNotifiche = useSelector((user) => user.user.notifiche);
  const arrayDestructured = getNotifiche && getNotifiche.map((r) => r);
  const getCausale =
    method === "RID"
      ? arrayDestructured[0].map((r) => (r === undefined ? null : r.causale))
      : arrayDestructured[1].map((r) => (r === undefined ? null : r.causale));

  const switchName = () => {
    switch (tag) {
      case "fattura":
        return "Fattura";
      case "rai":
        return "Canone RAI";

      default:
        return "Altri Oneri";
    }
  };

  const handleInvoice = () => {
    setOverlay(true);
    setInvoice(props.data);
  };
  return (
    <div className="item">
      {pagato === "1" ? (
        <div className="icon">
          <Check className="green" />
        </div>
      ) : (
        <div className="icon red">
          <Close className="red" />
        </div>
      )}
      <div className="info">
        <p className="date">{DateTime.fromISO(data_emissione).toFormat("D")}</p>
        <p className="main">{switchName()}</p>
        <p className="casuale">{numero_fattura}</p>
      </div>
      <div className="payment">
        {tag === "fattura" && pagato === "0" ? (
          <button onClick={() => navigate('/enrica/ricarica')}>
            {/* <Euro /> */}
            Ricarica
          </button>
        ) : pagato === "0" && !getCausale.includes(numero_fattura) ? (
          <button onClick={() => handleInvoice()}>
            {/* <Euro /> */}
            Paga adesso
          </button>
        ) : pagato === "0" && getCausale.includes(numero_fattura) ? (
          <button onClick={() => handleInvoice()}>
            {/* <Euro /> */}
            Pagamento inviato
          </button>
        ) : (
          <p className="amount">
          {/* <Euro /> */}
            {importo.toString().includes('-') ? parseFloat(importo).toFixed(2).replace(/\./g, ",") : `- ${parseFloat(importo).toFixed(2).replace(/\./g, ",")}`}
          </p>
        )}
      </div>
      <div className="download" onClick={() => window.open(`${url}`, "_blank")}>
        <DownloadIcon />
      </div>
    </div>
  );
}

export default Item;
